export const PROJECT_FORM = 'PROJECT_FORM';
export const GET_PROJECT = 'GET_PROJECT';
export const ADD_PROJECT = 'ADD_PROJECT';
export const VALIDATE_FORM = 'VALIDATE_FORM';
export const ACTUAL_PROJECT = 'ACTUAL_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const ERROR_PROJECT = 'ERROR_PROJECT';

export const TASK_PROJECT = 'TASK_PROJECT';
export const ADD_TASK = 'ADD_TASK';
export const VALIDATE_TASK = 'VALIDATE_TASK';
export const DELETE_TASK = 'DELETE_TASK';
//export const TASK_STATUS = 'TASK_STATUS';
export const ACTUAL_TASK = 'ACTUAL_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const CLEAN_TASK = 'CLEAN_TASK';

export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ ALERT';

export const SUCCESSFULL_REGISTER = 'SUCCESSFULL_REGISTER';
export const ERROR_REGISTER = 'ERROR_REGISTER';
export const GET_USER = 'GET_USER';
export const SUCCESSFULL_LOGIN = 'SUCCESSFULL_LOGIN';
export const ERROR_LOGIN = 'ERROR_LOGIN';
export const LOGOUT = 'LOGOUT';